import { ValidationErrorEnum } from './ValidationErrorEnum';
import { ValidationError, WalletValidatorFunction } from './types';

/**
 * Validates street address input
 * - Alphanumeric Start: First character must be a letter (A-Z) or number (0-9)
 * - Numeric Requirement: Must contain at least one numeric digit (0-9) anywhere
 * - Minimum Length: Must be at least 3 characters
 * Allows: unicode letters (including accented), numbers, spaces, hyphens, periods, commas, apostrophes, # (for apt numbers), forward slash
 * Prevents: SQL injection and special characters
 */
export const street1Validator: WalletValidatorFunction = (street1: any) => {
  const errors: ValidationError[] = [];

  if (typeof street1 !== 'string') {
    errors.push(ValidationErrorEnum.STRING_ERROR_MESSAGE);
    return [false, errors];
  }

  // Minimum 3 characters to prevent junk entries
  if (street1.length < 3) {
    errors.push(ValidationErrorEnum.INVALID_STREET_ADDRESS);
    return [false, errors];
  }

  // Must start with alphanumeric, then allow unicode letters, numbers, spaces, hyphens, periods, commas, apostrophes, #, /
  const streetRegex = /^[\p{L}0-9][\p{L}0-9\s\-.,#'/]*$/u;
  const formatValid = streetRegex.test(street1);

  // Must contain at least one digit anywhere in the string
  const hasDigit = /[0-9]/.test(street1);

  if (!formatValid || !hasDigit) {
    errors.push(ValidationErrorEnum.INVALID_STREET_ADDRESS);
  }

  return [errors.length === 0, errors];
};
